// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"11a3fadd","611":"5789ebfd"}[chunkId] + ".chunk.js";
};